import { PerformerEntity } from './performer.entity';

export class PositionPerformerEntity extends PerformerEntity {
    positionType: string;
    isRequired?: boolean;
    constructor() {
        super();
    }
}
